<mat-menu #actionMenu="matMenu"
    [overlapTrigger]="false">
    <div style="display: flex;flex-direction: column;">
        <button class="menuItem"
            mat-menu-item
            *ngFor="let item of topMenuItems; let i = index"
            (click)="topMenuItemClicked(i)">
            <div>
                <span [ngStyle]="{'color': this.isTopMenuItemDisabled(i) ? 'lightgray' : 'inherit'}">{{item}}</span>
            </div>
        </button>

        <ng-content class="menuItem">
        </ng-content>
        <div *ngIf="showSeparator"
            style="border-bottom:thin solid lightgray;"></div>

        <button class="menuItem"
            mat-menu-item
            *ngFor="let item of bottomMenuItems; let i = index"
            (click)="bottomMenuItemClicked(i)">
            <div>
                <span [ngStyle]="{'color': this.isBottomMenuItemDisabled(i) ? 'lightgray' : 'inherit'}">{{item}}</span>
            </div>
        </button>
    </div>
</mat-menu>